import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { doesRouteMatch } from "../../helpers";
import Container from "./styles";
import { useSelector } from "react-redux";

const Footer = () => {
  const { pathname } = useLocation();
  const { authenticated } = useSelector((s) => s.UserData);
  const navigate = useNavigate();

  return !doesRouteMatch(
    ["delievery-request", "auth", "dashboard"],
    pathname
  ) ? (
    <Container>
      <div className="grid--container">
        <div className="grid--item">
          <h3>astar.ng</h3>
          <p>
            Trusted Delivery Platform. Request a Collection from your home or
            office at the lowest online price available.
          </p>
          <div style={{ marginTop: 20 }}>
            <a href="buy.astar.ng">See More (buy.astar.ng)</a>
          </div>
        </div>
        <div className="grid--item">
          <h3
            onClick={() => {
              navigate("/support");
            }}
          >
            Contact us
          </h3>
          <p>
            <a href="tel:+2348043255678">+2348060088083</a>
          </p>
          <p>
            <a href="mailto:info@astar.ng">info@astar.ng</a>
          </p>
          <p>NO.59, AKEJU STREET, SHOMOLU, LAGOS.</p>
        </div>
        <div className="grid--item">
          <h3>Other Links</h3>
          <p>
            <Link to="/">About Us</Link>
          </p>
          <p>
            <Link to={authenticated ? "/orders" : "/auth/sign-in"}>Orders</Link>
          </p>
          <p>
            <Link to="/locations">Our locations</Link>
          </p>
          <p>
            <Link to={authenticated ? "/orders" : "/order"}>
              Track your orders
            </Link>
          </p>
        </div>
      </div>
      <hr />
      <div className="grid--container grid--bottom">
        <div className="grid--item">
          <p>©2022 astar.ng, All rights Reserved</p>
        </div>
        <div className="grid--item">
          <p>
            {" "}
            <a href={"/terms"} target={"__blank"}>
              Terms & Conditions
            </a>{" "}
            ·{" "}
            <a href={"/policy"} target={"__blank"}>
              Privacy Policy{" "}
            </a>
          </p>
        </div>
        <div className="grid--item">
          <p>
            <a href={"http://Instagram.com/astar"} target={"__blank"}>
            Instagram
            </a>
            ·
            <a href={"http://Twitter.com/astar"} target={"__blank"}>
            Twitter
            </a>
            ·
            <a href={"http://Facebook.com/astar"} target={"__blank"}>
              Facebook
            </a>
          </p>
        </div>
      </div>
    </Container>
  ) : null;
};

export default Footer;
